import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import noop from 'lodash/noop';

import { Button } from '@els/els-react--button';
import { Flyout } from '@els/els-react--flyout';
import { LinkElement } from '@els/els-react--link-element';

function UserDropdown({
  id,
  userName,
  userLinkText,
  userLinkHref,
  userLinkHandler,
  openLogoutDialog,
  userLinkClassName,
  isUserDropdownOpen,
  setUserDropdownOpen,
}) {
  return (
    <Flyout
      id={id}
      isControlled
      isOpen={isUserDropdownOpen}
      onToggle={setUserDropdownOpen}
      placement="bottom-end"
      pointer
      pointerType="primary"
      aria-label={userName === undefined ? userLinkText || 'User menu' : 'User menu'}
      shouldCloseOnESC
      showCloseButton
      flyout={
        <ul>
          {userName !== undefined && (
            <li className="u-els-margin-bottom-3o4">
              <span className="u-els-font-size-h4 u-els-margin-bottom-3o4">{userName}</span>
            </li>
          )}
          <li>
            <LinkElement
              data-e2e="user-dropdown-profile"
              iconSprite="Person"
              className={cn('e2e-user-profile', userLinkClassName)}
              href={userLinkHref}
              onClick={(e) => {
                e.preventDefault();
                setUserDropdownOpen(false);
                userLinkHandler();
              }}
              a11y={{ name: userLinkText }}>
              {userLinkText}
            </LinkElement>
          </li>
          <li>
            <LinkElement
              data-e2e="user-dropdown-sign-out"
              iconSprite="LogOut"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setUserDropdownOpen(false);
                openLogoutDialog();
              }}
              a11y={{ name: 'Sign out' }}>
              Sign out
            </LinkElement>
          </li>
        </ul>
      }>
      <Button
        data-e2e="user-dropdown-button"
        id="logged-in-user-dropdown-button"
        type="transparent"
        onClick={noop}
        aria-label={userName === undefined ? userLinkText : undefined}
        className="u-els-background-color-n7 profile-dd rounded-circle rx-cursor-pointer">
        {userName !== undefined && (
          <span className="rx-btn-text">
            <span className="rx-btn-text-container">{userName}</span>
          </span>
        )}
        <svg className="rx-btn-icon svg-icon">
          <use xlinkHref="#icon-user" />
        </svg>
      </Button>
    </Flyout>
  );
}

UserDropdown.propTypes = {
  id: PropTypes.string.isRequired,
  userName: PropTypes.string,
  userLinkText: PropTypes.string,
  userLinkClassName: PropTypes.string,
  userLinkHref: PropTypes.string,
  userLinkHandler: PropTypes.func.isRequired,
  openLogoutDialog: PropTypes.func.isRequired,
  isUserDropdownOpen: PropTypes.bool,
  setUserDropdownOpen: PropTypes.func.isRequired,
};

export default UserDropdown;
